import React, { useEffect, useRef, useCallback } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import * as chatActions from 'modules/chat';

import ChannelInfo from './ChannelInfo';
import ChatList from 'Components/ChatList';

import util from 'util/baseUtil';

const IssueRealtime = () => {
  const dispatch = useDispatch();

  const chatList = useSelector(state => state.chat.list);
  const chatLoading = useSelector(state => state.chat.db.loading);
  const chatLastPage = useSelector(state => state.chat.db.isLastPage);
  const activeChannel = useSelector(state => state.chat.activeChannel);

  const listState = useRef({
    isLoading: false,
    isLastPage: false,
  });

  const refOuter = useRef();

  const defaultRowSize = 96;


  useEffect(()=>{
    dispatch(chatActions.loadChat({room_id: activeChannel.room_id || ''}));
    util.scrollToTop()
  },[dispatch, activeChannel.room_id])

  
  useEffect(()=>{
    listState.current = {
      isLoading: chatLoading,
      isLastPage: chatLastPage,
    }
  },[chatLoading, chatLastPage]);


  
  /* 데이터 refresh 작업 예약 */
  let refreshTask = React.useRef(null);
  const schedulingRefreshTask = useCallback(()=>{
    clearTimeout(refreshTask.current);

    /* 매일 새벽 4시에 데이터 갱신 */
    let now = new Date();
    let refreshDate = new Date();
    refreshDate.setHours(4);
    refreshDate.setMinutes(0);
    refreshDate.setSeconds(0);
    refreshDate.setMilliseconds(0);

    if (refreshDate < now) {
      refreshDate.setDate(refreshDate.getDate()+1);
    }

    refreshTask.current = setTimeout(() => {
      /* refresh 작업 */
      dispatch(chatActions.loadChat({room_id: activeChannel.room_id || ''}));
      util.scrollToTop()
      
      schedulingRefreshTask();
    }, refreshDate.getTime() - now.getTime());
  },[dispatch, activeChannel.room_id]);

  
  useEffect(() => {
    schedulingRefreshTask();

    return (()=>{
      clearTimeout(refreshTask.current);
    })
  }, [schedulingRefreshTask]); 

  
  return (
    <section>
      <ChannelInfo activeChannel={activeChannel}/>
      <ChatList refOuter={refOuter} chatList={chatList} defaultRowSize={defaultRowSize} isLoading={chatLoading} />
    </section>
  )
}

export default IssueRealtime;